import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithErrorHandling } from './baseQuery';

export interface WorkflowInfo {
  workflow_id: string;
  workflow_type: string;
  status: string;
  run_id: string;
  artifact_id?: string;
  category?: string;
}

interface WorkflowsResponse {
  workflows: WorkflowInfo[];
}

export const workflowsApiClient = createApi({
  reducerPath: 'workflowsApi',
  baseQuery: baseQueryWithErrorHandling,
  tagTypes: ['Workflows'] as const,
  endpoints: (builder) => ({
    getMatterWorkflows: builder.query<WorkflowInfo[], string>({
      query: (matterId) => `api/matters/${matterId}/workflows/`,
      transformResponse: (response: WorkflowsResponse) => response.workflows,
      providesTags: (result, error, matterId) => [
        { type: 'Workflows', id: matterId },
      ],
    }),
  }),
});

export const { useGetMatterWorkflowsQuery } = workflowsApiClient;
